module.exports = __webpack_public_path__ + "media/images/iconSearch__inactive-90b6dd01f97e21b51799a8d4b299aa8d.png";